import React from "react";

import "./FaceScanner.css";

const RecordingDot = () => {

    return (
        <div className="pulsatingRecordingCircle"/>
    )
};

export default RecordingDot;